import React from 'react'
import Icon from 'shared/ui/Icon'
import { Link } from 'gatsby'
import { IconContent, IconContentText } from 'shared/ui/IconContent'

export default function WorkshopIntro() {
  return (
    <section className="offset-slant-background-image-left">
      <ul className="list-reset spacing">
        <IconContent as="li" className="spacing-xsmall">
          <IconContentText size={1.3}>
            <Icon name="check-circle" aria-hidden size={1.3} color="brightBlue" />
            <strong>Learn by doing</strong>
          </IconContentText>
          <p>The material lectures will be broken up by exercises so you can practice.</p>
        </IconContent>
        <IconContent as="li" className="spacing-xsmall">
          <IconContentText size={1.3}>
            <Icon name="check-circle" aria-hidden size={1.3} color="brightBlue" />
            <strong>Learn how React really works</strong>
          </IconContentText>
          <p>
            You'll leave our workshop with the correct mental model of how react works, and the
            correct terminology.
          </p>
        </IconContent>
        <IconContent as="li" className="spacing-xsmall">
          <IconContentText size={1.3}>
            <Icon name="check-circle" aria-hidden size={1.3} color="brightBlue" />
            <strong>Learn from professionals with years of experience</strong>
          </IconContentText>
          <p>
            At ReactTraining we help some of the biggest companies learn React including Google,
            Apple, Adobe, Netflix, Microsoft, Walmart, <Link to="/brands">and many more...</Link>
          </p>
        </IconContent>
      </ul>
    </section>
  )
}
